import { DynamicFormService } from '@ntap/common';
import { Component } from '@angular/core';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { Observable, filter, first, map, switchMap, tap } from 'rxjs';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';

@Component({
  selector: 'app-open-povezana-jedinica-gradiva',
  templateUrl: './open-povezana-jedinica-gradiva-action.component.html',
  providers: [
    {
      provide: ViewResultListener,
      useExisting: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenPovezanaJedinicaGradivaActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  static JEDINICA_GRADIVA_VIEW_NAME = 'jedinica_gradiva_item_readonly';

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.itemProvider.item$.pipe(
      first(),
      switchMap((item: any) => {
        const jgId =
          item['rel~jedinica_gradiva_veze~povezana_jedinica_gradiva_id'];

        const itemm: any = {
          $itemType: 'en~jedinica_gradiva',
          $mainType: 'en~jedinica_gradiva',
          $parentId: jgId,
          $parentType: 'en~jedinica_gradiva',
          'en~jedinica_gradiva~id': jgId
        };

        const itemProps =
          (jgId && {
            $id: jgId,
            $type: 'en~jedinica_gradiva',
            $itemType: 'en~jedinica_gradiva'
          }) ||
          {};

        const keyItem = ItemUtil.extractItemKey(itemm);

        const viewState = Object.assign({}, keyItem, itemProps);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          tap(() => this.log('result ACCEPTED')),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      OpenPovezanaJedinicaGradivaActionComponent.JEDINICA_GRADIVA_VIEW_NAME
    );

    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
